<template>
  <v-card class="card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold mb-5">Carrera policial</div>
      <v-tabs v-model="selectedTab" color="secondary" fixed-tabs>
        <v-tab class="font-weight-bold">Convocatorias</v-tab>
        <v-tab class="font-weight-bold">Condecoraciones</v-tab>
        <v-tab class="font-weight-bold">Evaluaciones de desempeño</v-tab>
        <v-tab class="font-weight-bold">Evaluaciones de desempeño académico</v-tab>
        <v-tab class="font-weight-bold">Evaluaciones anuales</v-tab>
        <v-tab class="font-weight-bold">CUP</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text>
      <v-tabs-items v-model="selectedTab" class="transparent">
        <v-tab-item key="1">
          <v-container>
            <v-row v-if="convocatorias.length > 0">
              <v-col cols="6" v-for="convocatoria in convocatorias" :key="convocatoria.idConvocatoria">
                <v-card color="primary" class="card">
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" align="center">
                          <div class="text-h6 font-weight-bold">{{ convocatoria.Convocatoria.convocatoria }}</div>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :value="convocatoria.fechaRegistro"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            label="Fecha de registro"
                          ></v-text-field>
                        </v-col>
                        <v-col>
                          <v-text-field
                            :value="convocatoria.Convocatoria.fechaHoraPublicacionConvocatoria"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            label="Fecha de publicación de convocatoria"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            :value="convocatoria.Convocatoria.plazasVacantes"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            label="Plazas vacantes"
                          ></v-text-field>
                          <v-text-field
                            :value="convocatoria.Convocatoria.lugarRecepcionDocumentos"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="primary"
                            color="secondary"
                            label="Lugar de recepción de documentos"
                          ></v-text-field>
                          <v-textarea
                            label="Convocatoria dirigida a"
                            :value="convocatoria.Convocatoria.dirigidaA"
                            rounded
                            filled
                            dense
                            color="secondary"
                            background-color="primary"
                            readonly
                            no-resize
                            rows="4"
                          ></v-textarea>
                          <v-textarea
                            label="Documentación solicitada"
                            :value="convocatoria.Convocatoria.documentacion"
                            rounded
                            filled
                            dense
                            color="secondary"
                            background-color="primary"
                            readonly
                            no-resize
                            rows="4"
                          ></v-textarea>
                          <v-textarea
                            label="Requisitos"
                            :value="convocatoria.Convocatoria.requisitos"
                            rounded
                            filled
                            dense
                            color="secondary"
                            background-color="primary"
                            readonly
                            no-resize
                            rows="4"
                          ></v-textarea>
                          <v-textarea
                            label="Beneficios"
                            :value="convocatoria.Convocatoria.beneficios"
                            rounded
                            filled
                            dense
                            color="secondary"
                            background-color="primary"
                            readonly
                            no-resize
                            rows="4"
                          ></v-textarea>
                          <v-textarea
                            label="Procedimiento de selección"
                            :value="convocatoria.Convocatoria.procedimientoSeleccion"
                            rounded
                            filled
                            dense
                            color="secondary"
                            background-color="primary"
                            readonly
                            no-resize
                            rows="4"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text--secondary text-h6">Este personal no se ha registrado en ninguna convocatoria.</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="2">
          <v-container>
            <v-row v-if="condecoraciones.length > 0">
              <v-col cols="12" v-for="condecoracion in condecoraciones" :key="condecoracion.id">
                <v-card color="primary" class="card">
                  <v-card-text>
                    <v-container>
                      <v-row align="center">
                        <v-col cols="4" align="center">
                          <v-img :src="condecoracion.CatCondecoracion.icono" width="80"></v-img>
                          <div class="text-subtitle-2 mt-4 font-weight-bold">
                            {{ condecoracion.CatCondecoracion.condecoracion }}
                          </div>
                          <div class="text-caption">
                            {{ condecoracion.CatCondecoracion.descripcion }}
                          </div>
                        </v-col>
                        <v-col cols="8">
                          <v-row>
                            <v-col cols="12" align="center">
                              <div class="text-h6 font-weight-bold">{{ condecoracion.CatCondecoracion.title }}</div>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                :value="condecoracion.fecha"
                                rounded
                                readonly
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Fecha de registro"
                              ></v-text-field>
                              <v-text-field
                                :value="condecoracion.fechaCondecoracion"
                                rounded
                                readonly
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Fecha de condecoración"
                              ></v-text-field>
                              <v-textarea
                                label="Observaciones"
                                :value="condecoracion.observaciones"
                                rounded
                                filled
                                dense
                                color="secondary"
                                background-color="primary"
                                readonly
                                no-resize
                                rows="4"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text-h6">Este personal no cuenta con condecoraciones.</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="3">
          <EvaluacionDesempenioTabContent
            :idPersonal="personal.idPersonal"
            :disciplinaAdministrativa="disciplinaAdministrativa"
            :disciplinaOperativa="disciplinaOperativa"
            :productividad="productividad"
            :respetoPrincipios="respetoPrincipios"
          />
        </v-tab-item>
        <v-tab-item key="4">
          <EvaluacionesDesempenioAcademicoTabContent />
        </v-tab-item>
        <v-tab-item key="5">
          <v-container>
            <EvaluacionesAnualesTable :evaluaciones="evaluacionesAnuales" :idPersonal="personal.idPersonal" />
          </v-container>
        </v-tab-item>
        <v-tab-item key="6">
          <v-container fill-height>
            <v-row>
              <v-col align="right">
                <TextButton @click="openCrearNuevoCup">REGISTRAR CUP</TextButton>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12">
                <v-data-table
                  :headers="headersCup"
                  :items="cups"
                  class="transparent"
                  hide-default-footer
                  disable-pagination
                >
                  <template v-slot:[`item.cup`]="{ item }">
                    <div style="white-space: pre-line">{{ item.cup || 'Sin información' }}</div>
                  </template>
                  <template v-slot:[`item.vigenciaCup`]="{ item }">
                    <div style="white-space: pre-line">{{ item.vigenciaCup || 'Sin vigencia' }}</div>
                  </template>
                  <template v-slot:[`item.observaciones`]="{ item }">
                    <div style="white-space: pre-line">{{ item.observaciones || 'Sin observaciones' }}</div>
                  </template>
                  <template v-slot:[`item.acciones`]="{ item }">
                    <v-tooltip v-if="item.urlAdjunto" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon color="secondary" small @click="mostrarAdjuntoCup(item)" v-bind="attrs" v-on="on">
                          <v-icon>mdi-download</v-icon>
                        </v-btn>
                      </template>
                      <span>Descargar adjunto CUP</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon color="secondary" small @click="openEditarCup(item)" v-bind="attrs" v-on="on">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar CUP</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { publicPath } from '../../../vue.config'
import EvaluacionProductividadCardComponent from './evaluaciones/productividad/EvaluacionProductividadCardComponent.vue'
import EvaluacionRespetoPrincipiosCardComponent from './evaluaciones/respeto_principios/EvaluacionRespetoPrincipiosCardComponent.vue'
import EvaluacionDisciplinaAdministrativaCardComponent from './evaluaciones/disciplina_administrativa/EvaluacionDisciplinaAdministrativaCardComponent.vue'
import EvaluacionDisciplinaOperativaCardComponent from './evaluaciones/disciplina_operativa/EvaluacionDisciplinaOperativaCardComponent.vue'
import EvaluacionRespetoPrincipiosValoresCardComponent from './evaluaciones/respeto_principios_valores/EvaluacionRespetoPrincipiosValoresCardComponent.vue'
import EvaluacionDesempenioInstitucionalCardComponent from './evaluaciones/desempeño_institucional/EvaluacionDesempenioInstitucionalCardComponent.vue'
import EvaluacionRendimientoProfesionalismoCardComponent from './evaluaciones/rendimiento_profesionalismo/EvaluacionRendimientoProfesionalismoCardComponent.vue'
import EvaluacionesAnualesTable from './evaluaciones/evaluacion_anual/EvaluacionesAnualesTable.vue'
import EvaluacionDesempenioTabContent from '../desarrollo_policial/evaluacion-desempeño/tabs/EvaluacionDesempenioTabContent.vue'
import EvaluacionesDesempenioAcademicoTabContent from '../desarrollo_policial/evaluacion-desempeño-academico/tab-content/EvaluacionesDesempenioAcademicoTabContent.vue'
import TextButton from '@src/components/base/TextButton.vue'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'

const ExcelJS = require('exceljs')
var buffer = null
var workbook = new ExcelJS.Workbook()
var worksheet = null
var cell = null

export default {
  components: {
    EvaluacionProductividadCardComponent,
    EvaluacionRespetoPrincipiosCardComponent,
    EvaluacionDisciplinaAdministrativaCardComponent,
    EvaluacionDisciplinaOperativaCardComponent,
    EvaluacionRespetoPrincipiosValoresCardComponent,
    EvaluacionDesempenioInstitucionalCardComponent,
    EvaluacionRendimientoProfesionalismoCardComponent,
    EvaluacionesAnualesTable,
    EvaluacionDesempenioTabContent,
    EvaluacionesDesempenioAcademicoTabContent,
    TextButton,
  },

  props: {
    personal: {
      type: Object,
    },
  },

  data() {
    return {
      selectedTab: 2,
      headersCup: [
        { text: 'CUP', value: 'cup' },
        { text: 'Vigencia de CUP', value: 'vigenciaCup' },
        { text: 'Observaciones', value: 'observaciones' },
        { text: 'Opciones', value: 'acciones', sortable: false },
      ],
      DIALOG_TYPES,
    }
  },

  computed: {
    ...mapGetters({ perfil: 'getPerfil' }),
    ...mapGetters('disciplinaAdministrativa', { disciplinaAdministrativa: 'getDisciplinaAdministrativa' }),
    ...mapGetters('disciplinaOperativa', { disciplinaOperativa: 'getDisciplinaOperativa' }),
    ...mapGetters('productividad', { productividad: 'getProductividad' }),
    ...mapGetters('respetoPrincipios', { respetoPrincipios: 'getRespetoPrincipios' }),
    ...mapGetters('respetoPrincipiosValores', { respetoPrincipiosValores: 'getRespetoPrincipiosValores' }),
    ...mapGetters('desempeñoInstitucional', { desempeñoInstitucional: 'getDesempeñoInstitucional' }),
    ...mapGetters('rendimientoProfesionalismo', { rendimientoProfesionalismo: 'getRendimientoProfesionalismo' }),
    ...mapGetters('evaluacionAnual', { evaluacionesAnuales: 'getEvaluacionAnual' }),
    ...mapGetters('cups', { cups: 'getCups' }),
    ...mapGetters('convocatoriaPersonal', { convocatorias: 'getConvocatoriaPersonal' }),
    ...mapGetters('condecoracionPersonal', { condecoraciones: 'getCondecoracionPersonal' }),

    cupItems() {
      return [
        {
          CUP: this.personal.CUP || '',
          vigenciaEvaluacionC3: this.personal.vigenciaEvaluacionC3 || '',
          vigenciaFormacionInicial: this.personal.vigenciaFormacionInicial || '',
          vigenciaCompetenciasBasicas: this.personal.vigenciaCompetenciasBasicas || '',
          vigenciaCup: this.personal.vigenciaCup || '',
          adjuntoCup: this.personal.adjuntoCup || '',
        },
      ]
    },
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('cups', ['fetchCupsById', 'createCup']),
    ...mapActions('convocatoriaPersonal', ['fetchConvocatoriaPersonal']),
    ...mapActions('condecoracionPersonal', ['fetchCondecoracionPersonal']),
    ...mapActions('evaluacionAnual', ['fetchEvaluacionAnual']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    async cargarCups() {
      if (this.personal && this.personal.idPersonal) {
        await this.fetchCupsById(this.personal.idPersonal)
      }
    },
    async exportExcel() {
      await axios(publicPath + 'cadena_resultados.xlsx', { responseType: 'arraybuffer' })
        .catch(function (err) {
          /* error in getting data */
          console.log('Error in getting data: ' + err)
        })
        .then(async function (res) {
          /* parse the data when it is received */
          return res.data
        })
        .catch(function (err) {
          /* error in parsing */
          console.log('Error in parsin: ' + err)
        })
        .then(async (data) => {
          await workbook.xlsx.load(data)
          worksheet = workbook.getWorksheet(1)
          cell = worksheet.getCell('E9')
          cell.value = this.getFullName(this.personal)
          cell = worksheet.getCell('F9')
          cell.value = this.personal.curp
          cell = worksheet.getCell('G9')
          cell.value = this.personal.CUIP
          cell = worksheet.getCell('H9')
          cell.value = this.personal.CatPuestoDependencia ? this.personal.CatPuestoDependencia.catPuesto.puesto : ''
          cell = worksheet.getCell('I9')
          cell.value = this.personal.antiguedad
          cell = worksheet.getCell('J9')
          cell.value = this.personal.CatPuestoDependencia ? this.personal.CatPuestoDependencia.CatTipoPuesto.title : ''
          cell = worksheet.getCell('K9')
          cell.value = this.personal.CatPuestoDependencia
            ? this.personal.CatPuestoDependencia.catDependencia.nombre
            : ''
          cell = worksheet.getCell('L9')
          cell.value = this.personal.CatArea ? this.personal.CatArea.nombre : ''
          cell = worksheet.getCell('N9')
          cell.value = this.respetoPrincipios[this.respetoPrincipios.length - 1].fechaAplicacion
          cell = worksheet.getCell('O9')
          cell.value = this.respetoPrincipios[this.respetoPrincipios.length - 1].puntajeTotal
          cell = worksheet.getCell('P9')
          cell.value = this.respetoPrincipios[this.respetoPrincipios.length - 1].calificacion
          cell = worksheet.getCell('Q9')
          cell.value = this.respetoPrincipios[this.respetoPrincipios.length - 1].CatResultado.title
          cell = worksheet.getCell('R9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].instanciaInforma
          cell = worksheet.getCell('S9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].fechaAplicacion
          cell = worksheet.getCell('T9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].incidencias[0].cantidad
          cell = worksheet.getCell('U9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].incidencias[1].cantidad
          cell = worksheet.getCell('V9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].incidencias[2].cantidad
          cell = worksheet.getCell('W9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].incidencias[3].cantidad
          cell = worksheet.getCell('X9')
          cell.value = this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].incidencias[4].cantidad
          cell = worksheet.getCell('Y9')
          cell.value = ''
          this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].actasAdministrativas.forEach(
            (acta, index) => {
              cell.value +=
                index +
                1 +
                '.' +
                'Descripción: ' +
                acta.descripcion +
                ' Fecha: ' +
                acta.fecha +
                ' Motivo: ' +
                acta.motivo +
                '\r\n'
            }
          )
          cell = worksheet.getCell('Z9')
          cell.value = ''
          this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].estimulos.forEach(
            (estimulo, index) => {
              cell.value +=
                index + 1 + '.' + 'Motivo: ' + estimulo.motivo + ' Descripción: ' + estimulo.descripcion + '\r\n'
            }
          )
          cell = worksheet.getCell('AA9')
          cell.value = ''
          this.disciplinaAdministrativa[this.disciplinaAdministrativa.length - 1].reconocimientos.forEach(
            (reconocimiento, index) => {
              cell.value +=
                index +
                1 +
                '.' +
                'Motivo: ' +
                reconocimiento.motivo +
                ' Descripción: ' +
                reconocimiento.descripcion +
                '\r\n'
            }
          )
          cell = worksheet.getCell('AB9')
          cell.value = this.disciplinaOperativa[this.disciplinaOperativa.length - 1].instanciaInforma
          cell = worksheet.getCell('AC9')
          cell.value = this.disciplinaOperativa[this.disciplinaOperativa.length - 1].fechaAplicacion
          cell = worksheet.getCell('AH9')
          cell.value = ''
          this.disciplinaOperativa[this.disciplinaOperativa.length - 1].procedimientos.forEach(
            (procedimiento, index) => {
              cell.value += index + 1 + '.' + procedimiento.numero + '\r\n'
            }
          )
          cell = worksheet.getCell('AI9')
          cell.value = ''
          this.disciplinaOperativa[this.disciplinaOperativa.length - 1].procedimientos.forEach(
            (procedimiento, index) => {
              cell.value += index + 1 + '.' + procedimiento.fecha + '\r\n'
            }
          )
          cell = worksheet.getCell('AN9')
          cell.value = this.productividad[this.productividad.length - 1].fechaAplicacion
          cell = worksheet.getCell('AO9')
          cell.value = this.productividad[this.productividad.length - 1].puntajeTotal
          cell = worksheet.getCell('AP9')
          cell.value = this.productividad[this.productividad.length - 1].calificacion
          cell = worksheet.getCell('AQ9')
          cell.value = this.productividad[this.productividad.length - 1].CatResultado.title

          worksheet.removeConditionalFormatting()
          buffer = await workbook.xlsx.writeBuffer()
        })

      var blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      saveAs(blob, 'cadena_resultados.xlsx')
    },
    mostrarAdjuntoCup(item) {
      if (item.urlAdjunto) {
        this.download(item.urlAdjunto)
      } else {
        this.SET_SNACKBAR_MESSAGE('No hay un archivo adjunto disponible para este CUP.')
      }
    },
    openCrearNuevoCup() {
      this.SET_DIALOG({
        ...DIALOG_TYPES.CREAR_NUEVO_CUP,
        props: { idPersonal: this.personal.idPersonal },
      })
    },
    openEditarCup(cup) {
      console.log('CUP seleccionado:', cup)
      if (!cup || !cup.idHistCup) {
        console.error('El CUP seleccionado no es válido:', cup)
        this.SET_SNACKBAR_MESSAGE('El CUP seleccionado no tiene un identificador válido.')
        return
      }

      this.SET_DIALOG({
        ...DIALOG_TYPES.EDITAR_CUP,
        props: { idPersonal: this.personal.idPersonal, cupToUpdate: cup },
      })
    },
  },

  async mounted() {
    this.cargarCups()
    if (this.personal && this.personal.idPersonal) {
      try {
        await Promise.all([
          this.fetchConvocatoriaPersonal(this.personal.idPersonal),
          this.fetchCondecoracionPersonal(this.personal.idPersonal),
          this.fetchEvaluacionAnual(this.personal.idPersonal),
        ])
      } catch (error) {
        console.error('Error cargando datos de carrera policial:', error)
      }
    }
  },
}
</script>
